import React from "react";

import { Button, Dialog, DialogContent, Grid, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import { RETRO_PAGES } from "components/retrospective/RetrospectiveData";
import {
  CustomCodes,
  ERROR_ILLUSTRATIONS,
  ErrorResponse,
} from "contexts/ErrorContextData";
import { CREATE_ROUTER_MANUAL } from "routers/routePaths";
import { useClearError } from "contexts/ErrorContext";

export const ErrorDialog = ({
  isDialogOpen,
  onClose,
  errorInfo,
}: ErrorDialogProps) => {
  const history = useHistory();
  const clearError = useClearError();

  const handleCTA = () => {
    switch (errorInfo?.code) {
      case CustomCodes.WIFI_MEASUREMENT_FAILED:
        history.push(CREATE_ROUTER_MANUAL);
        onClose();
        clearError();
        break;
      case CustomCodes.INVALID_FORM:
      case CustomCodes.INCOMPLETE_FORM:
        onClose();
        break;
      case "RETRO":
        history.push(RETRO_PAGES.WELCOME);
        onClose();
        clearError();
        break;
      default:
        onClose();
        clearError();
    }
  };

  const imgSrc =
    errorInfo?.code && !!ERROR_ILLUSTRATIONS[errorInfo.code]
      ? ERROR_ILLUSTRATIONS[errorInfo.code]
      : ERROR_ILLUSTRATIONS.DEFAULT;

  return (
    <Dialog open={isDialogOpen} onClose={onClose}>
      <DialogContent sx={{ display: "flex" }}>
        <Grid
          item
          container
          direction="column"
          justifyContent="space-around"
          alignItems="center"
          sx={{ flex: 1 }}
          gap={3}
        >
          <img src={imgSrc} alt="" width="70%" />
          <Typography variant="subtitle1" fontWeight="bold" align="center">
            {errorInfo?.message || ""}
          </Typography>
          <Typography align="center">{errorInfo?.description || ""}</Typography>
          <Button fullWidth variant="contained" onClick={handleCTA}>
            {errorInfo?.cta || ""}
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export type ErrorDialogProps = {
  isDialogOpen: boolean;
  onClose: () => void;
  errorInfo?: ErrorResponse;
};
